<template>
	<button
		class="header__cart cart-icon"
		@click.prevent="onCartOpen"
	>
			<SVGCart class="header__cart-icon"/>
			<span
				class="header__cart-count"
				v-if="totalItemsWithoutAdditional"
				v-html="totalItemsWithoutAdditional"
			/>
	</button>
</template>

<script>
import { mapGetters } from "vuex"
import htmlComponent from "htmlcomponent"
import scrrroll from 'scrrroll';

export default {
	mixins: [],
	components: {},
	data() {
		return {
			overlayType: 'sidebar-cart',
		};
	},
	computed: {
		...mapGetters("cart", [
			"total",
			"totalItemsWithoutAdditional",
			"hasBasket",
			"showContinue",
		])
	},
	methods: {
		onCartOpen() {
			if (this.hasBasket) {
				htmlComponent.send('overlay:toggle', {type: this.overlayType});
			} else {
				this.$store.dispatch('redirect', { name: 'shop' })
			}
		}
	}
}
</script>

<style></style>
